import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57;

var _excluded = ["children"],
    _excluded2 = ["theme"],
    _excluded3 = ["prefixIcon", "suffixIcon", "borderRadius", "inputSize", "labelText", "variant", "fullWidth"],
    _excluded4 = ["children"],
    _excluded5 = ["className", "options", "fullWidth", "labelText", "borderRadius", "selectSize"],
    _excluded6 = ["children", "trim"],
    _excluded7 = ["children", "trim"],
    _excluded8 = ["className", "alt", "bgColor", "name"],
    _excluded9 = ["caption", "captionPosition", "className", "captionSpacing"],
    _excluded10 = ["children", "className"],
    _excluded11 = ["className", "children"],
    _excluded12 = ["children", "open", "onClose", "initialFocus", "unmount", "className", "as"],
    _excluded13 = ["as", "className", "children"],
    _excluded14 = ["children", "className", "as"],
    _excluded15 = ["children", "className"],
    _excluded16 = ["children"],
    _excluded17 = ["children", "className", "size", "width", "fullWidth", "showIcon", "iconPosition"],
    _excluded18 = ["children", "className", "header"],
    _excluded19 = ["children", "className"],
    _excluded20 = ["className"],
    _excluded21 = ["children", "className"],
    _excluded22 = ["children", "type", "href", "className", "prefixIcon", "suffixIcon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef, createContext, useContext } from 'react';
import styled from '@emotion/styled';
import { keyframes, useTheme, css, ThemeContext, Global } from '@emotion/react';
export { ThemeContext } from '@emotion/react';
import isValidProp from '@emotion/is-prop-valid';
import { Dialog, Disclosure } from '@headlessui/react';
import { ChevronDown } from 'react-feather';

var getButtonShape = function getButtonShape(shape) {
  switch (shape) {
    case 'curve':
      return theme.components.buttonTheme.borders.curve;

    case 'round':
      return theme.components.buttonTheme.borders.round;

    case 'square':
      return "0";

    default:
      throw new Error('Please pass in an appropriate buttton shape');
  }
};

var trimButtonText = function trimButtonText(text) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

  if (limit > text.length) {
    return text;
  }

  return "".concat(text.substr(0, limit), "...");
};

var _ = function _(t) {
  return t;
},
    _t;

var ButtonIcon = function ButtonIcon(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement(StyledButton, Object.assign({}, props), children);
};

var StyledButton = styled.span(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n"])))));

var _$1 = function _$1(t) {
  return t;
},
    _t$1,
    _t2;

var spin = keyframes(_t$1 || (_t$1 = _$1(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    0% { -webkit-transform: rotate(0deg); }\n    100% { -webkit-transform: rotate(360deg); }\n"])))));

var Spinner = function Spinner(_ref2) {
  var theme = _ref2.theme,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var _className = props.className ? "avocado-spinner ".concat(props.className) : "avocado-spinner";

  var avocadoTheme = useTheme();
  return React.createElement(StyledSpinner, Object.assign({}, props, {
    theme: avocadoTheme,
    className: _className
  }));
};

var StyledSpinner = styled.span(_t2 || (_t2 = _$1(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border: 3px solid #fff;\n  border-radius: 50%;\n  border-top: 3px solid\n    ", ";\n  border-right: 3px solid\n    ", ";\n  width: ", ";\n  display: inline-block;\n  height: ", ";\n  animation: ", " 0.4s linear infinite;\n  box-sizing: border-box;\n"])), 0, 0, 0, 0, 0)), function (_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme;
  return variant && (theme === null || theme === void 0 ? void 0 : theme.components.spinnerTheme.variants[variant]);
}, function (_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return variant && (theme === null || theme === void 0 ? void 0 : theme.components.spinnerTheme.variants[variant]);
}, function (_ref5) {
  var size = _ref5.size,
      theme = _ref5.theme;
  return size && (theme === null || theme === void 0 ? void 0 : theme.components.spinnerTheme.sizes[size]);
}, function (_ref6) {
  var size = _ref6.size,
      theme = _ref6.theme;
  return size && (theme === null || theme === void 0 ? void 0 : theme.components.spinnerTheme.sizes[size]);
}, spin);
Spinner.displayName = 'Spinner';
Spinner.defaultProps = {
  variant: 'primary',
  size: 'md'
};

var _$2 = function _$2(t) {
  return t;
},
    _t$2,
    _t2$1,
    _t3,
    _t4,
    _t5,
    _t6;

var Button = forwardRef(function (props, ref) {
  var buttonType = props.buttonType,
      trim = props.trim,
      prefixIcon = props.prefixIcon,
      suffixIcon = props.suffixIcon,
      disabled = props.disabled,
      loading = props.loading;
  var avocadoTheme = useTheme();

  var _classNames = props.className ? "avocado-btn ".concat(props.className) : "avocado-btn";

  return React.createElement(StyledButton$1, Object.assign({
    buttonType: buttonType
  }, props, {
    theme: avocadoTheme,
    disabled: disabled || loading,
    loading: loading || undefined,
    className: _classNames,
    ref: ref
  }), prefixIcon && !loading && React.createElement(ButtonIcon, {
    className: 'btn-icon--left'
  }, prefixIcon), loading && buttonType !== 'link' && React.createElement(Spinner, {
    className: 'avocado-btn__spinner',
    variant: props.variant
  }), typeof props.children === 'string' && trim ? trimButtonText(props.children, trim) : props.children, suffixIcon && !loading && React.createElement(ButtonIcon, {
    className: 'btn-icon--right'
  }, suffixIcon));
});

var BaseButton = function BaseButton(_ref7) {
  var shape = _ref7.shape,
      size = _ref7.size,
      theme = _ref7.theme,
      loading = _ref7.loading,
      disabled = _ref7.disabled,
      fullWidth = _ref7.fullWidth;
  return shape && css(_t$2 || (_t$2 = _$2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding: 0.5em 0.8em;\n    font: inherit;\n    font-size: ", ";\n    cursor: pointer;\n    border: none;\n    box-sizing: border-box;\n    color: ", ";\n    background: ", ";\n    width: ", ";\n    user-select: none;\n    transition: background, color, transform;\n    transition-duration: 0.15s;\n    transition-timing-function: ease-out;\n    user-select: none;\n\n    border-radius: ", ";\n    padding: ", ";\n\n    opacity: ", ";\n\n    display: ", ";\n    align-items: center;\n\n    .btn-icon--left,\n    .btn-icon--right {\n      height: 15px;\n      width: 15px;\n\n      display: inline-flex;\n\n      svg {\n        height: 100%;\n        width: 100%;\n        margin: auto;\n      }\n    }\n\n    .btn-icon--left {\n      margin-right: 0.35em;\n    }\n\n    .btn-icon--right {\n      margin-left: 0.35em;\n    }\n\n    .avocado-btn__spinner {\n      margin-right: 0.5em;\n    }\n\n    :focus {\n      outline: none;\n      transform: none;\n      box-shadow: 0 0 0 3px ", ";\n    }\n\n    :disabled,\n    :disabled:hover {\n      cursor: not-allowed;\n      border: ", ";\n      color: ", ";\n      background: ", ";\n      transform: none;\n      text-decoration: none;\n    }\n\n    :hover {\n      transform: ", ";\n    }\n\n    :hover:active {\n      transform: translateY(0px);\n    }\n\n    :active {\n      background: ", ";\n    }\n  "])), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), size === 'sm' ? '14px' : "inherit", theme === null || theme === void 0 ? void 0 : theme.colors.gray[8], theme === null || theme === void 0 ? void 0 : theme.colors.gray[4], fullWidth ? "100%" : "auto", shape && getButtonShape(shape), "".concat(size && (theme === null || theme === void 0 ? void 0 : theme.components.buttonTheme.size[size]), " ").concat(size && (theme === null || theme === void 0 ? void 0 : theme.components.buttonTheme.size[size])), loading && 0.4, !fullWidth && "inline-flex", theme === null || theme === void 0 ? void 0 : theme.colors.blue[100], !loading && "1px solid ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.gray[6]), !loading && (theme === null || theme === void 0 ? void 0 : theme.colors.gray[8]), !loading && theme && (theme === null || theme === void 0 ? void 0 : theme.colors.gray[3]), !loading && !disabled && "translateY(-1px)", theme === null || theme === void 0 ? void 0 : theme.colors.gray[4]);
};

var StyledSolidButton = function StyledSolidButton(_ref8) {
  var buttonType = _ref8.buttonType,
      theme = _ref8.theme,
      variant = _ref8.variant;
  return buttonType === 'solid' && css(_t2$1 || (_t2$1 = _$2(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    background: ", ";\n\n    color: ", ";\n\n    &:hover {\n      background: ", ";\n    }\n  "])), 0, 0, 0)), variant && (theme === null || theme === void 0 ? void 0 : theme.components.buttonTheme.variants[variant].default), theme === null || theme === void 0 ? void 0 : theme.colors.white, variant && (theme === null || theme === void 0 ? void 0 : theme.components.buttonTheme.variants[variant].hover));
};

var StyledOutlineButton = function StyledOutlineButton(_ref9) {
  var buttonType = _ref9.buttonType,
      variant = _ref9.variant,
      theme = _ref9.theme;
  return buttonType === 'outline' && css(_t3 || (_t3 = _$2(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    background: inherit;\n    border: 1px solid\n      ", ";\n    color: ", ";\n  "])), 0, 0)), variant && (theme === null || theme === void 0 ? void 0 : theme.components.buttonTheme.variants[variant].hover), variant && (theme === null || theme === void 0 ? void 0 : theme.components.buttonTheme.variants[variant].hover));
};

var StyledGhostButton = function StyledGhostButton(_ref10) {
  var buttonType = _ref10.buttonType,
      variant = _ref10.variant,
      theme = _ref10.theme;
  return buttonType === 'ghost' && css(_t4 || (_t4 = _$2(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    background: inherit;\n    border: 2px solid ", ";\n    color: ", ";\n\n    :hover {\n      border-color: ", ";\n    }\n  "])), 0, 0, 0)), theme === null || theme === void 0 ? void 0 : theme.colors.gray[3], variant && (theme === null || theme === void 0 ? void 0 : theme.components.buttonTheme.variants[variant].hover), theme === null || theme === void 0 ? void 0 : theme.colors.gray[4]);
};

var StyledLinkButton = function StyledLinkButton(_ref11) {
  var buttonType = _ref11.buttonType,
      theme = _ref11.theme;
  return buttonType === 'link' && css(_t5 || (_t5 = _$2(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    background: none;\n    padding: 0;\n    color: ", ";\n\n    :hover {\n      text-decoration: underline;\n    }\n    :active {\n      text-decoration: none;\n    }\n  "])), 0)), theme === null || theme === void 0 ? void 0 : theme.colors.blue[400]);
};

var StyledButton$1 = styled('button', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isValidProp(prop) && prop !== 'loading' && prop !== 'shape';
  }
})(_t6 || (_t6 = _$2(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), 0, 0, 0, 0, 0)), BaseButton, StyledSolidButton, StyledOutlineButton, StyledGhostButton, StyledLinkButton);
Button.defaultProps = {
  size: 'md',
  shape: 'curve',
  buttonType: 'solid',
  variant: 'primary',
  loading: false
};
Button.displayName = 'Button';
var red = {
  '50': '#fff1f0',
  '100': '#ffccc7',
  '200': '#ffa39e',
  '300': '#ff7875',
  '400': '#ff4d4f',
  '500': '#f5222d',
  '600': '#cf1322',
  '700': '#a8071a',
  '800': '#820014',
  '900': '5c0011'
};
var blue = {
  '50': '#E6F7FF',
  '100': '#BAE7FF',
  '200': '#91d5ff',
  '300': '#69c0ff',
  '400': '#40a9ff',
  '500': '#1890ff',
  '600': '#096dd9',
  '700': '#0050b3',
  '800': '#003a8c',
  '900': '#002766'
};
var green = {
  '50': '#f6ffed',
  '100': '#d9f7be',
  '200': '#b7eb8f',
  '300': '#95de64',
  '400': '#73d13d',
  '500': '#52c41a',
  '600': '#389e0d',
  '700': '#237804',
  '800': '#135200',
  '900': '#092b00'
};
var cyan = {
  '50': '#e6fffb',
  '100': '#b5f5ec',
  '200': '#87e8de',
  '300': '#5cdbd3',
  '400': '#36cfc9',
  '500': '#13c2c2',
  '600': '#08979c',
  '700': '#006d75',
  '800': '#00474f',
  '900': '#002329'
};
var yellow = {
  '50': '#feffe6',
  '100': '#ffffb8',
  '200': '#fffb8f',
  '300': '#fff566',
  '400': '#ffec3d',
  '500': '#fadb14',
  '600': '#d4b106',
  '700': '#ad8b00',
  '800': '#876800',
  '900': '#614700'
};
var gray = {
  '1': '#ffffff',
  '2': '#fafafa',
  '3': '#f5f5f5',
  '4': '#f0f0f0',
  '5': '#d9d9d9',
  '6': '#bfbfbf',
  '7': '#8c8c8c',
  '8': '#595959',
  '9': '#434343',
  '10': '#262626',
  '11': '#1f1f1f',
  '12': '#141414',
  '13': '#000000'
};
var primary = blue[500];
var white = gray[1];
var black = gray[13];
var colors = {
  red: red,
  blue: blue,
  green: green,
  cyan: cyan,
  yellow: yellow,
  gray: gray,
  white: white,
  primary: primary,
  black: black
};
var border = {
  sm: '4px',
  full: '10000px',
  none: '0px'
};
var spacing = {
  '2x-small': '0.125rem',
  'x-small': '0.25rem',
  small: '0.5rem',
  medium: '0.75rem',
  large: '0.85rem',
  'x-large': '1rem',
  '1.3x-large': '1.3rem',
  '2x-large': '1.5rem',
  '3x-large': '2rem',
  '3.3x-large': '2.3rem',
  '4x-large': '3rem',
  '5x-large': '4rem',
  '6x-large': '4.4rem',
  '7x-large': '6rem',
  '8x-large': '9rem',
  '9x-large': '18rem'
};
var typography = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  '2xl': '1.5rem',
  '3xl': '1.75rem',
  '4xl': '2rem',
  '5xl': '2.5rem',
  '6xl': '3rem',
  '7xl': '4rem'
};
var buttonTheme = {
  variants: {
    primary: {
      default: colors.primary,
      hover: colors.blue[400]
    },
    error: {
      default: colors.red[400],
      hover: colors.red[300]
    },
    success: {
      default: colors.green[500],
      hover: colors.green[400]
    },
    warning: {
      default: colors.yellow[500],
      hover: colors.yellow[500]
    }
  },
  borders: {
    round: border.full,
    curve: border.sm
  },
  size: {
    sm: "".concat(spacing.small, " ").concat(spacing.medium),
    md: "".concat(spacing.small, " ").concat(spacing.medium),
    lg: "".concat(spacing.medium, " ").concat(spacing.large)
  }
};

var generateButtonTheme = function generateButtonTheme(userTheme, buttonTheme) {
  var primaryColor = userTheme.primaryColor,
      secondaryColor = userTheme.secondaryColor;

  var newButtonTheme = _objectSpread(_objectSpread({}, buttonTheme), {}, {
    variants: _objectSpread(_objectSpread({}, buttonTheme.variants), {}, {
      primary: {
        default: primaryColor || buttonTheme.variants.primary.default,
        hover: secondaryColor || buttonTheme.variants.primary.hover
      }
    })
  });

  return newButtonTheme;
};

var inputTheme = {
  outlineColor: colors.blue[500],
  focusColor: colors.blue[200],
  variants: {
    fill: {
      default: {
        background: colors.gray[6],
        textColor: colors.gray[9]
      },
      hover: {},
      focus: {}
    },
    outline: {
      default: colors.red[400],
      hover: colors.red[300]
    },
    unstyled: {
      default: colors.green[500],
      hover: colors.green[400]
    }
  },
  size: {
    sm: {
      verticalPadding: spacing['x-small'],
      horizontalPadding: spacing.small
    },
    md: {
      verticalPadding: spacing.small,
      horizontalPadding: spacing.medium
    },
    lg: {
      verticalPadding: spacing.medium,
      horizontalPadding: spacing.large
    }
  }
};

var generateInputTheme = function generateInputTheme(userTheme, inputTheme) {
  var primaryColor = userTheme.primaryColor,
      focusColor = userTheme.focusColor;

  var newInputTheme = _objectSpread(_objectSpread({}, inputTheme), {}, {
    outlineColor: primaryColor || inputTheme.outlineColor,
    focusColor: focusColor || inputTheme.focusColor
  });

  return newInputTheme;
};

var selectTheme = {
  variants: {
    fill: {
      default: {
        background: colors.gray[6],
        textColor: colors.gray[9]
      },
      hover: {},
      focus: {}
    },
    outline: {
      default: colors.red[400],
      hover: colors.red[300]
    },
    unstyled: {
      default: colors.green[500],
      hover: colors.green[400]
    }
  },
  size: {
    sm: {
      verticalPadding: spacing['x-small'],
      horizontalPadding: spacing.small
    },
    md: {
      verticalPadding: spacing.small,
      horizontalPadding: spacing.medium
    },
    lg: {
      verticalPadding: spacing.medium,
      horizontalPadding: spacing.large
    }
  }
};
var avatarTheme = {
  sizes: {
    xs: 24,
    sm: 32,
    md: 40,
    lg: 64,
    xl: 84
  },
  fontSizes: {
    xs: 8,
    sm: 14,
    md: 16,
    lg: 26,
    xl: 40
  },
  radius: {
    round: border.full,
    square: 0,
    curve: border.sm
  },
  bgColor: colors.blue[400]
};

var generateAvatarTheme = function generateAvatarTheme(userTheme, spinnerTheme) {
  var primaryColor = userTheme.primaryColor;

  var newAvatarTheme = _objectSpread(_objectSpread({}, spinnerTheme), {}, {
    bgColor: primaryColor || spinnerTheme.bgColor
  });

  return newAvatarTheme;
};

var imageTheme = {
  borders: {
    curve: border.sm,
    round: border.full,
    square: 0
  },
  size: {
    xs: '40px',
    sm: '80px',
    md: '120px',
    lg: '160px',
    xl: '200px'
  }
};
var spinnerTheme = {
  sizes: {
    sm: '1em',
    md: '1.25em',
    lg: '1.5em'
  },
  variants: {
    primary: colors.primary,
    warning: colors.yellow[500],
    error: colors.red[400],
    success: colors.green[500]
  }
};

var generateSpinnerTheme = function generateSpinnerTheme(userTheme, spinnerTheme) {
  var primaryColor = userTheme.primaryColor;

  var newSpinnerTheme = _objectSpread(_objectSpread({}, spinnerTheme), {}, {
    variants: _objectSpread(_objectSpread({}, spinnerTheme.variants), {}, {
      primary: primaryColor || spinnerTheme.variants.primary
    })
  });

  return newSpinnerTheme;
};

var accordionTheme = {
  border: colors.gray[4],
  panelBackground: colors.gray[3],
  sizes: {
    sm: {
      fontSize: "0.875em",
      margin: "0.5em"
    },
    md: {
      fontSize: "1em",
      margin: "0.5em"
    },
    lg: {
      fontSize: "1em",
      margin: "0.625em"
    }
  }
};
var linkTheme = {
  variants: {
    primary: {
      default: colors.primary,
      hover: colors.blue[400]
    }
  },
  borders: {
    round: border.full,
    curve: border.sm
  },
  size: {
    sm: "".concat(spacing.small, " ").concat(spacing.medium),
    md: "".concat(spacing.small, " ").concat(spacing.medium),
    lg: "".concat(spacing.medium, " ").concat(spacing.large)
  }
};

var generateLinkTheme = function generateLinkTheme(userTheme, linkTheme) {
  var primaryColor = userTheme.primaryColor,
      secondaryColor = userTheme.secondaryColor;

  var newLinkTheme = _objectSpread(_objectSpread({}, linkTheme), {}, {
    variants: _objectSpread(_objectSpread({}, linkTheme.variants), {}, {
      primary: {
        default: primaryColor || linkTheme.variants.primary.default,
        hover: secondaryColor || linkTheme.variants.primary.hover
      }
    })
  });

  return newLinkTheme;
};

var theme = {
  colors: colors,
  borders: border,
  spacing: spacing,
  typography: typography,
  components: {
    buttonTheme: buttonTheme,
    inputTheme: inputTheme,
    avatarTheme: avatarTheme,
    imageTheme: imageTheme,
    linkTheme: linkTheme,
    spinnerTheme: spinnerTheme
  }
};

var generateTheme = function generateTheme(_ref12) {
  var primaryColor = _ref12.primaryColor,
      secondaryColor = _ref12.secondaryColor,
      focusColor = _ref12.focusColor;
  var buttonTheme$1 = generateButtonTheme({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    focusColor: focusColor
  }, buttonTheme);
  var spinnerTheme$1 = generateSpinnerTheme({
    primaryColor: primaryColor
  }, spinnerTheme);
  var avatarTheme$1 = generateAvatarTheme({
    primaryColor: primaryColor
  }, avatarTheme);
  var inputTheme$1 = generateInputTheme({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    focusColor: focusColor
  }, inputTheme);
  var linkTheme$1 = generateLinkTheme({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  }, linkTheme);

  var compositeAppTheme = _objectSpread(_objectSpread({}, theme), {}, {
    colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
      primary: primaryColor || theme.colors.primary
    }),
    components: _objectSpread(_objectSpread({}, theme.components), {}, {
      buttonTheme: buttonTheme$1,
      spinnerTheme: spinnerTheme$1,
      avatarTheme: avatarTheme$1,
      inputTheme: inputTheme$1,
      linkTheme: linkTheme$1
    })
  });

  return compositeAppTheme;
};

var ThemeProvider = function ThemeProvider(_ref13) {
  var userTheme = _ref13.theme,
      children = _ref13.children;
  var primaryColor = userTheme.primaryColor,
      secondaryColor = userTheme.secondaryColor,
      focusColor = userTheme.focusColor;
  var mergedTheme = generateTheme({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    focusColor: focusColor
  });
  return React.createElement(ThemeContext.Provider, {
    value: mergedTheme
  }, children);
};

var getBorderRadius = function getBorderRadius(borderRadius) {
  switch (borderRadius) {
    case 'curve':
      return border.full;

    case 'round':
      return border.sm;

    case 'square':
      return "none";

    default:
      throw new Error('Please pass in a borderRadius');
  }
};

var getInputIconSize = function getInputIconSize(size) {
  switch (size) {
    case 'sm':
      return theme.spacing['1.3x-large'];

    case 'md':
    case 'lg':
      return theme.spacing['2x-large'];

    default:
      throw new Error('Please psas in a size');
  }
};

var InputIcon = function InputIcon(_ref14) {
  var props = Object.assign({}, _ref14);

  var _className = props.className ? "".concat(props.className, " avocado-input__icon") : "avocado-input__icon";

  return React.createElement("span", Object.assign({}, props, {
    className: _className
  }));
};

var _$3 = function _$3(t) {
  return t;
},
    _t$3,
    _t2$2,
    _t3$1,
    _t4$1;

var Input = function Input(_ref15) {
  var prefixIcon = _ref15.prefixIcon,
      suffixIcon = _ref15.suffixIcon,
      borderRadius = _ref15.borderRadius,
      inputSize = _ref15.inputSize,
      labelText = _ref15.labelText,
      variant = _ref15.variant,
      fullWidth = _ref15.fullWidth,
      props = _objectWithoutProperties(_ref15, _excluded3);

  var avocadoTheme = useTheme();
  if (variant === 'unstyled') return React.createElement("input", Object.assign({}, props));

  var _className = props.className ? "".concat(props.className, " avocado-input__control avocado-input__control--").concat(variant) : "avocado-input__control avocado-input__control--".concat(variant);

  if (labelText) return React.createElement(StyledInput, {
    className: 'avocado-input',
    variant: variant,
    theme: avocadoTheme,
    inputSize: inputSize,
    borderRadius: borderRadius,
    fullWidth: fullWidth,
    prefixIcon: prefixIcon,
    suffixIcon: suffixIcon
  }, React.createElement("label", null, React.createElement("span", {
    className: 'avocado-input__label-text'
  }, labelText), React.createElement("span", {
    className: 'avocado-input__control-container'
  }, prefixIcon && React.createElement(InputIcon, {
    className: 'left'
  }, prefixIcon), React.createElement("input", Object.assign({}, props, {
    className: _className
  })), suffixIcon && React.createElement(InputIcon, {
    className: 'right'
  }, suffixIcon))));
  return React.createElement(StyledInput, {
    className: 'avocado-input',
    variant: variant,
    theme: avocadoTheme,
    inputSize: inputSize,
    borderRadius: borderRadius,
    fullWidth: fullWidth,
    prefixIcon: prefixIcon,
    suffixIcon: suffixIcon
  }, prefixIcon && React.createElement(InputIcon, {
    className: 'left'
  }, prefixIcon), React.createElement("input", Object.assign({}, props, {
    className: _className
  })), suffixIcon && React.createElement(InputIcon, {
    className: 'right'
  }, suffixIcon));
};

var StyledBaseInput = function StyledBaseInput(_ref16) {
  var disabled = _ref16.disabled,
      inputSize = _ref16.inputSize,
      borderRadius = _ref16.borderRadius,
      prefixIcon = _ref16.prefixIcon,
      fullWidth = _ref16.fullWidth,
      theme = _ref16.theme,
      suffixIcon = _ref16.suffixIcon;
  return css(_t$3 || (_t$3 = _$3(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  width: ", ";\n\n  .avocado-input__label-text {\n    display: block;\n    margin-bottom: 0.3em;\n  }\n\n  .avocado-input__control-container {\n    display: flex;\n    align-items: center;\n    position: relative;\n  }\n\n  .avocado-input__control {\n    border: 1px solid ", ";\n    font: inherit;\n    font-size: ", ";\n    padding: ", "\n      ", ";\n\n    padding-left: ", ";\n\n    padding-right: ", ";\n\n    transition: border-color, background;\n    transition-duration: 0.25s;\n    border-radius: ", ";\n    width: ", ";\n\n    transition-timing-function: ease-out;\n\n    :hover {\n      // border: ", ";\n      border: ", ";\n    }\n\n    :focus {\n      outline: none;\n      box-shadow: 0 0 0 2px ", ";\n    }\n\n    :disabled {\n      cursor: not-allowed;\n      background: ", ";\n      border: none;\n      user-select: none;\n    }\n  }\n\n  .avocado-input__icon {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    display: flex;\n\n    width: ", ";\n    height: ", ";\n\n    pointer-events: none;\n    color: ", ";\n    > * {\n      margin: auto;\n    }\n    font-size: 0.875em;\n  }\n  .avocado-input__icon.left {\n    left: 0;\n    padding-left: 0.5em;\n  }\n  .avocado-input__icon.right {\n    right: 0;\n    padding-right: 0.5em;\n  }\n\n  svg {\n    height: 100%;\n    width: 100%;\n    margin: auto;\n  }\n"])), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), fullWidth ? '100%' : 'auto', theme === null || theme === void 0 ? void 0 : theme.colors.gray[5], inputSize === 'sm' && '14px', inputSize && (theme === null || theme === void 0 ? void 0 : theme.components.inputTheme.size[inputSize].verticalPadding), inputSize && (theme === null || theme === void 0 ? void 0 : theme.components.inputTheme.size[inputSize].horizontalPadding), prefixIcon && (inputSize === 'sm' ? theme === null || theme === void 0 ? void 0 : theme.spacing['3x-large'] : theme === null || theme === void 0 ? void 0 : theme.spacing['3.3x-large']), suffixIcon && (inputSize === 'sm' ? theme === null || theme === void 0 ? void 0 : theme.spacing['3x-large'] : theme === null || theme === void 0 ? void 0 : theme.spacing['3.3x-large']), borderRadius && getBorderRadius(borderRadius), fullWidth ? '100%' : 'auto', !disabled && "1px solid ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.blue[500]), !disabled && "1px solid ".concat(theme === null || theme === void 0 ? void 0 : theme.components.inputTheme.outlineColor), theme === null || theme === void 0 ? void 0 : theme.components.inputTheme.focusColor, theme === null || theme === void 0 ? void 0 : theme.colors.gray[3], inputSize && getInputIconSize(inputSize), inputSize && getInputIconSize(inputSize), theme === null || theme === void 0 ? void 0 : theme.colors.gray[6]);
};

var StyledFilledInput = function StyledFilledInput(_ref17) {
  var variant = _ref17.variant,
      disabled = _ref17.disabled,
      theme = _ref17.theme;
  return variant === 'fill' && css(_t2$2 || (_t2$2 = _$3(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    .avocado-input__control {\n      border: none;\n      background: ", ";\n      border: 1px solid transparent;\n\n      &:hover {\n        border: none;\n        border: ", ";\n      }\n\n      &:active,\n      &:focus {\n        background: ", ";\n      }\n    }\n  "])), 0, 0, 0)), theme === null || theme === void 0 ? void 0 : theme.colors.gray[4], !disabled && "1px solid ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.gray[5]), !disabled && "inherit");
};

var StyledOutlineInput = function StyledOutlineInput(_ref18) {
  var variant = _ref18.variant;
  return variant === 'outline' && css(_t3$1 || (_t3$1 = _$3(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral([""])))));
};

var StyledInput = styled.span(_t4$1 || (_t4$1 = _$3(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n"])), 0, 0, 0)), StyledBaseInput, StyledFilledInput, StyledOutlineInput);
Input.defaultProps = {
  variant: 'outline',
  inputSize: 'md',
  borderRadius: 'round'
};
Input.displayName = 'Input';

var Radio = function Radio(_ref19) {
  var children = _ref19.children,
      props = _objectWithoutProperties(_ref19, _excluded4);

  var _className = props.className ? "avocado-radio ".concat(props.className) : "avocado-radio";

  return React.createElement("label", {
    className: _className
  }, React.createElement("input", Object.assign({}, props, {
    type: 'radio',
    className: 'avocado-radio__control'
  })), React.createElement("span", null, children));
};

var RadioGroup = function RadioGroup(_ref20) {
  var children = _ref20.children;
  return React.createElement("span", {
    className: 'avocado-radio'
  }, children);
};

Radio.displayName = 'Radio';

var _$4 = function _$4(t) {
  return t;
},
    _t$4,
    _t2$3,
    _t3$2;

var Select = function Select(_ref21) {
  var className = _ref21.className,
      options = _ref21.options,
      fullWidth = _ref21.fullWidth,
      labelText = _ref21.labelText,
      borderRadius = _ref21.borderRadius,
      selectSize = _ref21.selectSize,
      props = _objectWithoutProperties(_ref21, _excluded5);

  var _className = className ? "avocado-select__control avocado-select--".concat(props.variant, " ").concat(className) : "avocado-select__control avocado-select--".concat(props.variant);

  if (props.variant === 'unstyled') return React.createElement("select", Object.assign({}, props, {
    className: _className
  }));
  if (labelText) return React.createElement(StyledSelect, {
    options: options,
    className: 'avocado-select',
    selectSize: selectSize,
    borderRadius: borderRadius,
    fullWidth: fullWidth
  }, React.createElement("label", {
    className: 'avocado-select__label'
  }, React.createElement("span", {
    className: 'avocado-select__labeltext'
  }, labelText), React.createElement("select", Object.assign({
    className: _className
  }, props), options.map(function (option) {
    return React.createElement("option", {
      key: option.value,
      value: option.value
    }, option.displayText);
  }))));
  return React.createElement(StyledSelect, {
    className: 'avocado-select',
    options: options,
    selectSize: selectSize,
    borderRadius: borderRadius,
    fullWidth: fullWidth
  }, React.createElement("select", Object.assign({
    className: _className
  }, props), options.map(function (option) {
    return React.createElement("option", {
      key: option.value,
      value: option.value
    }, option.displayText);
  })));
};

var StyledBaseSelect = function StyledBaseSelect(_ref22) {
  var selectSize = _ref22.selectSize,
      disabled = _ref22.disabled,
      borderRadius = _ref22.borderRadius,
      fullWidth = _ref22.fullWidth;
  return css(_t$4 || (_t$4 = _$4(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: ", ";\n\n  .avocado-select__labeltext {\n    user-select: none;\n    margin-bottom: 0.3em;\n    display: inline-block;\n  }\n  .avocado-select__label {\n    display: block;\n    max-width: ", ";\n  }\n  .avocado-select__control {\n    display: block;\n    width: 100%;\n    border: 1px solid ", ";\n    font: inherit;\n    font-size: ", ";\n    padding: ", "\n      ", ";\n\n    transition: border-color, background;\n    transition-duration: 0.25s;\n    border-radius: ", ";\n\n    transition-timing-function: ease-out;\n\n    :hover {\n      border: ", ";\n    }\n\n    :focus {\n      outline: none;\n      box-shadow: 0 0 0 2px ", ";\n    }\n\n    :disabled {\n      cursor: not-allowed;\n      background: ", ";\n      border: none;\n      user-select: none;\n    }\n  }\n"])), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), fullWidth ? '100%' : 'auto', !fullWidth && "18em", theme.colors.gray[5], selectSize === 'sm' && '14px', selectSize && selectTheme.size[selectSize].verticalPadding, selectSize && selectTheme.size[selectSize].horizontalPadding, borderRadius && getBorderRadius(borderRadius), !disabled && "1px solid ".concat(theme.colors.blue[500]), theme.colors.blue[200], theme.colors.gray[3]);
};

var StyledFilledSelect = function StyledFilledSelect(_ref23) {
  var variant = _ref23.variant,
      disabled = _ref23.disabled;
  return variant === 'fill' && css(_t2$3 || (_t2$3 = _$4(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    border: none;\n    background: ", ";\n    border: 1px solid transparent;\n\n    &:hover {\n      border: none;\n      border: ", ";\n    }\n\n    &:active,\n    &:focus {\n      background: ", ";\n    }\n  "])), 0, 0, 0)), theme.colors.gray[4], !disabled && "1px solid ".concat(theme.colors.gray[5]), !disabled && "inherit");
};

var StyledSelect = styled.span(_t3$2 || (_t3$2 = _$4(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), 0, 0)), StyledBaseSelect, StyledFilledSelect);
Select.defaultProps = {
  borderRadius: 'round',
  selectSize: 'md',
  variant: 'outline'
};
Select.displayName = 'Select';

var trimText = function trimText(text, limit) {
  if (limit > text.length) {
    return text;
  }

  return "".concat(text.substr(0, limit), "...");
};

var _$5 = function _$5(t) {
  return t;
},
    _t$5,
    _t2$4,
    _t3$3,
    _t4$2,
    _t5$1,
    _t6$1,
    _t7;

var Heading = function Heading(_ref24) {
  var children = _ref24.children,
      trim = _ref24.trim,
      props = _objectWithoutProperties(_ref24, _excluded6);

  var _className = props.className ? "avocado-heading ".concat(props.className) : "avocado-heading";

  switch (props.level) {
    case 'h1':
      return React.createElement(StyledH1, Object.assign({}, props, {
        className: _className
      }), typeof children === 'string' && trim ? trimText(children, trim) : children);

    case 'h2':
      return React.createElement(StyledH2, Object.assign({}, props, {
        className: _className
      }), typeof children === 'string' && trim ? trimText(children, trim) : children);

    case 'h3':
      return React.createElement(StyledH3, Object.assign({}, props, {
        className: _className
      }), typeof children === 'string' && trim ? trimText(children, trim) : children);

    case 'h4':
      return React.createElement(StyledH4, Object.assign({}, props, {
        className: _className
      }), typeof children === 'string' && trim ? trimText(children, trim) : children);

    case 'h5':
      return React.createElement(StyledH5, Object.assign({}, props, {
        className: _className
      }), typeof children === 'string' && trim ? trimText(children, trim) : children);

    case 'h6':
      return React.createElement(StyledH6, Object.assign({}, props, {
        className: _className
      }), typeof children === 'string' && trim ? trimText(children, trim) : children);

    default:
      throw new Error('Missing prop:level. Please specify a level for the Heading');
  }
};

var StyledHeadingBase = function StyledHeadingBase(_ref25) {
  var align = _ref25.align;
  return css(_t$5 || (_t$5 = _$5(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  line-height: 1.2;\n  text-align: ", ";\n"])), 0)), align);
};

var StyledH1 = styled.h1(_t2$4 || (_t2$4 = _$5(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  ", ";\n"])), 0, 0)), function (_ref26) {
  var size = _ref26.size;
  return size ? theme.typography[size] : theme.typography['6xl'];
}, StyledHeadingBase);
var StyledH2 = styled.h2(_t3$3 || (_t3$3 = _$5(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  ", ";\n"])), 0, 0)), function (_ref27) {
  var size = _ref27.size;
  return size ? theme.typography[size] : theme.typography['5xl'];
}, StyledHeadingBase);
var StyledH3 = styled.h3(_t4$2 || (_t4$2 = _$5(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  ", ";\n"])), 0, 0)), function (_ref28) {
  var size = _ref28.size;
  return size ? theme.typography[size] : theme.typography['4xl'];
}, StyledHeadingBase);
var StyledH4 = styled.h4(_t5$1 || (_t5$1 = _$5(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  ", ";\n"])), 0, 0)), function (_ref29) {
  var size = _ref29.size;
  return size ? theme.typography[size] : theme.typography['3xl'];
}, StyledHeadingBase);
var StyledH5 = styled.h5(_t6$1 || (_t6$1 = _$5(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  ", ";\n"])), 0, 0)), function (_ref30) {
  var size = _ref30.size;
  return size ? theme.typography[size] : theme.typography['2xl'];
}, StyledHeadingBase);
var StyledH6 = styled.h6(_t7 || (_t7 = _$5(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  ", ";\n"])), 0, 0)), function (_ref31) {
  var size = _ref31.size;
  return size ? theme.typography[size] : theme.typography.xl;
}, StyledHeadingBase);
Heading.displayName = 'Heading';

var _$6 = function _$6(t) {
  return t;
},
    _t$6,
    _t2$5;

var Text = function Text(_ref32) {
  var children = _ref32.children,
      trim = _ref32.trim,
      props = _objectWithoutProperties(_ref32, _excluded7);

  var _className = props.className ? "avocado-text ".concat(props.className) : "avocado-text";

  return React.createElement(StyledText, Object.assign({}, props, {
    className: _className
  }), typeof children === 'string' && trim ? trimText(children, trim) : children);
};

var StyledTextStyles = function StyledTextStyles(_ref33) {
  var align = _ref33.align,
      size = _ref33.size;
  return css(_t$6 || (_t$6 = _$6(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  margin-top: 0;\n  text-align: ", ";\n  font-size: ", ";\n"])), 0, 0)), align, size && theme.typography[size]);
};

var StyledText = styled.p(_t2$5 || (_t2$5 = _$6(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  ", "\n"])), 0)), StyledTextStyles);
Text.displayName = 'Text';

var getInitials = function getInitials(text) {
  var nameArr = text.trim().split(' ');

  if (nameArr.length <= 1) {
    return "".concat(nameArr[0][0]).concat(nameArr[0][1]);
  }

  return "".concat(nameArr[0][0]).concat(nameArr[1][0]);
};

var _$7 = function _$7(t) {
  return t;
},
    _t$7,
    _t2$6,
    _t3$4,
    _t4$3;

var Avatar = function Avatar(_ref34) {
  var className = _ref34.className,
      alt = _ref34.alt,
      defaultBgColor = _ref34.bgColor,
      name = _ref34.name,
      props = _objectWithoutProperties(_ref34, _excluded8);

  var avocaoTheme = useTheme();
  var bgColor = defaultBgColor || avocaoTheme.components.avatarTheme.bgColor;

  var _className = className ? "avocado-avatar avocado-avatar__".concat(props.size, " ").concat(className) : "avocado-avatar avocado-avatar__".concat(props.size);

  if (props.src) return React.createElement(StyledAvatar, Object.assign({}, props, {
    title: name,
    bgColor: bgColor,
    theme: avocaoTheme,
    className: _className,
    alt: alt || name
  }));
  if (props.icon) return React.createElement(StyledAvatarSpan, Object.assign({
    title: name,
    theme: avocaoTheme,
    className: _className,
    role: 'img',
    "aria-label": name,
    bgColor: bgColor
  }, props), React.createElement("span", null, props.icon));
  return React.createElement(StyledAvatarInitials, Object.assign({
    title: name,
    theme: avocaoTheme,
    className: _className,
    "aria-label": name,
    bgColor: bgColor
  }, props), React.createElement("span", null, name && getInitials(name)));
};

var StyledAvatarBase = function StyledAvatarBase(_ref35) {
  var size = _ref35.size,
      shape = _ref35.shape,
      theme = _ref35.theme;
  return size && shape && css(_t$7 || (_t$7 = _$7(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    pointer: cursor;\n\n    height: ", "px;\n\n    width: ", "px;\n\n    text-align: center;\n    border-radius: ", ";\n    display: flex;\n    object-fit: cover;\n    color: #fff;\n    cursor: pointer;\n    user-select: none;\n    font-size: ", "px;\n  "])), 0, 0, 0, 0)), size && typeof size === 'number' ? "".concat(size) : size && (theme === null || theme === void 0 ? void 0 : theme.components.avatarTheme.sizes[size]), size && typeof size === 'number' ? "".concat(size) : size && (theme === null || theme === void 0 ? void 0 : theme.components.avatarTheme.sizes[size]), avatarTheme.radius[shape], typeof size === 'number' ? size / 2 : avatarTheme.fontSizes[size]);
};

var StyledAvatar = styled.img(_t2$6 || (_t2$6 = _$7(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  ", ";\n"])), 0)), StyledAvatarBase);
var StyledAvatarInitials = styled.span(_t3$4 || (_t3$4 = _$7(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  ", ";\n  background: ", ";\n  span {\n    margin: auto;\n  }\n"])), 0, 0)), StyledAvatarBase, function (_ref36) {
  var bgColor = _ref36.bgColor,
      theme = _ref36.theme;
  return bgColor || (theme === null || theme === void 0 ? void 0 : theme.components.avatarTheme.bgColor);
});
var StyledAvatarSpan = styled.span(_t4$3 || (_t4$3 = _$7(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  ", ";\n  background: ", ";\n  span {\n    margin: auto;\n    display: block;\n    width: 70%;\n    height: 70%;\n\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  }\n"])), 0, 0)), StyledAvatarBase, function (_ref37) {
  var bgColor = _ref37.bgColor,
      theme = _ref37.theme;
  return bgColor || (theme === null || theme === void 0 ? void 0 : theme.components.avatarTheme.bgColor);
});
Avatar.defaultProps = {
  size: 'md',
  shape: 'round'
};

var AvatarGroup = function AvatarGroup(props) {
  return React.createElement("div", Object.assign({}, props, {
    style: {
      display: 'flex'
    }
  }));
};

var getFigureAlignment = function getFigureAlignment(position) {
  switch (position) {
    case 'topCenter':
    case 'bottomCenter':
      return 'center';

    case 'topLeft':
    case 'bottomLeft':
      return 'left';

    case 'topRight':
    case 'bottomRight':
      return 'right';

    default:
      throw new Error('Please specify a caption position to the Image component');
  }
};

var _$8 = function _$8(t) {
  return t;
},
    _t$8,
    _t2$7,
    _t3$5,
    _t4$4;

var Image = function Image(_ref38) {
  var caption = _ref38.caption,
      captionPosition = _ref38.captionPosition,
      className = _ref38.className,
      captionSpacing = _ref38.captionSpacing,
      props = _objectWithoutProperties(_ref38, _excluded9);

  var _className = className ? "avocado-img ".concat(className) : "avocado-img";

  var position = captionPosition !== null && captionPosition !== void 0 && captionPosition.startsWith('top') ? 'top' : 'bottom';
  if (!caption) return React.createElement(StyledImage, Object.assign({}, props, {
    className: _className
  }));
  return React.createElement(StyledFigure, {
    captionPosition: captionPosition,
    className: 'avocado-img__figure',
    maxWidth: props.size
  }, position === 'top' && React.createElement("figcaption", {
    className: 'avocado-img__figcaption',
    style: {
      marginBottom: "".concat(captionSpacing, "px")
    }
  }, caption), React.createElement(StyledImage, Object.assign({}, props, {
    className: _className
  })), position === 'bottom' && React.createElement("figcaption", {
    className: 'avocado-img__figcaption',
    style: {
      marginTop: "".concat(captionSpacing, "px")
    }
  }, caption));
};

var StyledImageCSS = function StyledImageCSS(_ref39) {
  var size = _ref39.size,
      shape = _ref39.shape,
      objectFit = _ref39.objectFit;
  return shape && size && css(_t$8 || (_t$8 = _$8(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n    border-radius: ", ";\n    height: ", ";\n    width: ", ";\n    object-fit: ", ";\n  "])), 0, 0, 0, 0)), imageTheme.borders[shape], typeof size === 'number' ? "".concat(size, "px") : imageTheme.size[size], typeof size === 'number' ? "".concat(size, "px") : imageTheme.size[size], objectFit);
};

var StyledImage = styled.img(_t2$7 || (_t2$7 = _$8(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  ", "\n"])), 0)), StyledImageCSS);

var StyledFigureCSS = function StyledFigureCSS(_ref40) {
  var captionPosition = _ref40.captionPosition,
      maxWidth = _ref40.maxWidth;
  return captionPosition && maxWidth && css(_t3$5 || (_t3$5 = _$8(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n    margin: 0;\n    figcaption {\n      text-align: ", ";\n    }\n    display: inline-block;\n    max-width: ", ";\n  "])), 0, 0)), getFigureAlignment(captionPosition), typeof maxWidth === 'number' ? "".concat(maxWidth, "px") : imageTheme.size[maxWidth]);
};

var StyledFigure = styled.figure(_t4$4 || (_t4$4 = _$8(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  ", "\n"])), 0)), StyledFigureCSS);
Image.defaultProps = {
  size: 'md',
  shape: 'square',
  objectFit: 'fill',
  captionPosition: 'bottomCenter'
};
Image.displayName = 'Image';

var _$9 = function _$9(t) {
  return t;
},
    _t$9;

var CSSReset = function CSSReset() {
  return React.createElement(Global, {
    styles: css(_t$9 || (_t$9 = _$9(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n      /*\n\tHTML5 Reset :: style.css\n\t----------------------------------------------------------\n\tWe have learned much from/been inspired by/taken code where offered from:\n\n\tEric Meyer\t\t\t\t\t:: http://meyerweb.com\n\tHTML5 Doctor\t\t\t\t:: http://html5doctor.com\n\tand the HTML5 Boilerplate\t:: http://html5boilerplate.com\n\n-------------------------------------------------------------------------------*/\n\n      /* Let's default this puppy out\n-------------------------------------------------------------------------------*/\n\n      html,\n      body,\n      body div,\n      span,\n      object,\n      iframe,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6,\n      p,\n      blockquote,\n      pre,\n      abbr,\n      address,\n      cite,\n      code,\n      del,\n      dfn,\n      em,\n      img,\n      ins,\n      kbd,\n      q,\n      samp,\n      small,\n      strong,\n      sub,\n      sup,\n      var,\n      b,\n      i,\n      dl,\n      dt,\n      dd,\n      ol,\n      ul,\n      li,\n      fieldset,\n      form,\n      label,\n      legend,\n      table,\n      caption,\n      tbody,\n      tfoot,\n      thead,\n      tr,\n      th,\n      td,\n      article,\n      aside,\n      figure,\n      footer,\n      header,\n      menu,\n      nav,\n      section,\n      time,\n      mark,\n      audio,\n      video,\n      details,\n      summary {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        font-size: 100%;\n        font-weight: normal;\n        vertical-align: baseline;\n        background: transparent;\n      }\n\n      p {\n        margin-bottom: 1em;\n      }\n\n      html {\n        line-height: 1.5;\n      }\n      * {\n        line-height: inherit;\n      }\n\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6 {\n        line-height: 1.25;\n        margin-bottom: 0.5rem;\n      }\n\n      main,\n      article,\n      aside,\n      figure,\n      footer,\n      header,\n      nav,\n      section,\n      details,\n      summary {\n        display: block;\n      }\n\n      /* Handle box-sizing while better addressing child elements:\n   http://css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice/ */\n      html {\n        box-sizing: border-box;\n      }\n\n      *,\n      *:before,\n      *:after {\n        box-sizing: border-box;\n      }\n\n      /* consider resetting the default cursor: https://gist.github.com/murtaugh/5247154 */\n\n      /* Responsive images and other embedded objects */\n      /* if you don't have full control over img tags (if you have to overcome attributes), consider adding height: auto */\n      img,\n      object,\n      embed {\n        max-width: 100%;\n      }\n\n      /* force a vertical scrollbar to prevent a jumpy page */\n      html {\n        overflow-y: scroll;\n        font-family: --apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n          Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n      }\n\n      /* we use a lot of ULs that aren't bulleted.\n\tyou'll have to restore the bullets within content,\n\twhich is fine because they're probably customized anyway */\n      ul {\n        list-style: none;\n      }\n\n      blockquote,\n      q {\n        quotes: none;\n      }\n\n      blockquote:before,\n      blockquote:after,\n      q:before,\n      q:after {\n        content: '';\n        content: none;\n      }\n\n      a {\n        margin: 0;\n        padding: 0;\n        font-size: 100%;\n        vertical-align: baseline;\n        background: transparent;\n      }\n\n      del {\n        text-decoration: line-through;\n      }\n\n      abbr[title],\n      dfn[title] {\n        border-bottom: 1px dotted #000;\n        cursor: help;\n      }\n\n      /* tables still need cellspacing=\"0\" in the markup */\n      table {\n        border-collapse: separate;\n        border-spacing: 0;\n      }\n      th {\n        font-weight: bold;\n        vertical-align: bottom;\n      }\n      td {\n        font-weight: normal;\n        vertical-align: top;\n      }\n\n      hr {\n        display: block;\n        height: 1px;\n        border: 0;\n        border-top: 1px solid #ccc;\n        margin: 1em 0;\n        padding: 0;\n      }\n\n      input,\n      select {\n        vertical-align: middle;\n      }\n\n      pre {\n        white-space: pre; /* CSS2 */\n        white-space: pre-wrap; /* CSS 2.1 */\n        white-space: pre-line; /* CSS 3 (and 2.1 as well, actually) */\n        word-wrap: break-word; /* IE */\n      }\n\n      input[type='radio'] {\n        vertical-align: text-bottom;\n      }\n      input[type='checkbox'] {\n        vertical-align: bottom;\n      }\n      .ie7 input[type='checkbox'] {\n        vertical-align: baseline;\n      }\n      .ie6 input {\n        vertical-align: text-bottom;\n      }\n\n      select,\n      input,\n      textarea {\n        font: 99% sans-serif;\n      }\n\n      table {\n        font-size: inherit;\n        font: 100%;\n      }\n\n      small {\n        font-size: 85%;\n      }\n\n      strong {\n        font-weight: bold;\n      }\n\n      td,\n      td img {\n        vertical-align: top;\n      }\n\n      /* Make sure sup and sub don't mess with your line-heights http://gist.github.com/413930 */\n      sub,\n      sup {\n        font-size: 75%;\n        line-height: 0;\n        position: relative;\n      }\n      sup {\n        top: -0.5em;\n      }\n      sub {\n        bottom: -0.25em;\n      }\n\n      /* standardize any monospaced elements */\n      pre,\n      code,\n      kbd,\n      samp {\n        font-family: monospace, sans-serif;\n      }\n\n      /* hand cursor on clickable elements */\n      .clickable,\n      label,\n      input[type='button'],\n      input[type='submit'],\n      input[type='file'],\n      button {\n        cursor: pointer;\n      }\n\n      /* Webkit browsers add a 2px margin outside the chrome of form elements */\n      button,\n      input,\n      select,\n      textarea {\n        margin: 0;\n      }\n\n      /* make buttons play nice in IE */\n      button,\n      input[type='button'] {\n        width: auto;\n        overflow: visible;\n      }\n\n      /* scale images in IE7 more attractively */\n      .ie7 img {\n        -ms-interpolation-mode: bicubic;\n      }\n\n      /* prevent BG image flicker upon hover\n    (commented out as usage is rare, and the filter syntax messes with some pre-processors)\n    .ie6 html {filter: expression(document.execCommand(\"BackgroundImageCache\", false, true));}\n    */\n\n      /* let's clear some floats */\n      .clearfix:after {\n        content: ' ';\n        display: block;\n        clear: both;\n      }\n    "])))))
  });
};

var _$a = function _$a(t) {
  return t;
},
    _t$a,
    _t2$8;

var Flex = function Flex(_ref41) {
  var children = _ref41.children,
      className = _ref41.className,
      props = _objectWithoutProperties(_ref41, _excluded10);

  var _className = className ? "".concat(className, " avocado-flex") : "avocado-flex";

  return React.createElement(StyledFlex, Object.assign({}, props, {
    className: _className
  }), children);
};

var StyledFlexCSS = function StyledFlexCSS(_ref42) {
  var flexFlow = _ref42.flexFlow,
      flexWrap = _ref42.flexWrap,
      alignContent = _ref42.alignContent,
      gap = _ref42.gap,
      justifyContent = _ref42.justifyContent,
      flexDirection = _ref42.flexDirection,
      alignItems = _ref42.alignItems;
  return css(_t$a || (_t$a = _$a(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: ", ";\n  align-content: ", ";\n  justify-content: ", ";\n  flex-wrap: ", ";\n  flex-flow: ", ";\n  flex-direction: ", ";\n  width: 100%;\n\n  // hack to implement flex gap on flexbox\n  margin: calc(", "px / -2) calc(", "px / -2);\n\n  // margin on the flex child component\n  > * {\n    margin: calc(", "px / 2) calc(", "px / 2);\n  }\n"])), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), alignItems, alignContent, justifyContent && justifyContent, flexWrap && flexWrap, flexFlow && flexFlow, flexDirection, gap, gap, gap, gap);
};

var StyledFlex = styled.div(_t2$8 || (_t2$8 = _$a(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  ", "\n"])), 0)), StyledFlexCSS);
Flex.defaultProps = {
  flexWrap: 'nowrap',
  alignContent: 'normal',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  flexDirection: 'row'
};
Flex.displayName = 'Flex';

var _$b = function _$b(t) {
  return t;
},
    _t$b,
    _t2$9;

var FlexItem = function FlexItem(_ref43) {
  var className = _ref43.className,
      children = _ref43.children,
      props = _objectWithoutProperties(_ref43, _excluded11);

  var _className = className ? "".concat(className, " avocado-flex__item") : "avocado-flex__item";

  return React.createElement(StlyedFlexItem, Object.assign({}, props, {
    className: _className
  }), children);
};

var StyledFlexItemCSS = function StyledFlexItemCSS(_ref44) {
  var order = _ref44.order,
      flexGrow = _ref44.flexGrow,
      flexShrink = _ref44.flexShrink,
      flexBasis = _ref44.flexBasis,
      flex = _ref44.flex,
      alignSelf = _ref44.alignSelf;
  return css(_t$b || (_t$b = _$b(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  order: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-basis: ", ";\n  flex: ", ";\n  align-self: ", ";\n"])), 0, 0, 0, 0, 0, 0)), order && order, flexGrow && flexGrow, flexShrink && flexShrink, flexBasis && flexBasis, flex && flex, alignSelf && alignSelf);
};

var StlyedFlexItem = styled.div(_t2$9 || (_t2$9 = _$b(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  ", "\n"])), 0)), StyledFlexItemCSS);
FlexItem.displayName = 'FlexItem';

var _$c = function _$c(t) {
  return t;
},
    _t$c;

var Modal = function Modal(_ref45) {
  var children = _ref45.children,
      open = _ref45.open,
      onClose = _ref45.onClose,
      initialFocus = _ref45.initialFocus,
      unmount = _ref45.unmount,
      className = _ref45.className,
      as = _ref45.as,
      props = _objectWithoutProperties(_ref45, _excluded12);

  var _className = className ? "avocado-modal ".concat(className) : "avocado-modal";

  return React.createElement(StyledModal, Object.assign({
    onClose: onClose,
    unmount: unmount,
    as: as || 'div',
    initialFocus: initialFocus,
    open: open
  }, props, {
    className: _className,
    "data-modalopen": open ? true : null
  }), children);
};

var StyledModal = styled(Dialog)(_t$c || (_t$c = _$c(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 10;\n  width: 100%;\n  top: 2.5em;\n"])))));

var _$d = function _$d(t) {
  return t;
},
    _t$d;

var Description = Dialog.Description;

var ModalContent = function ModalContent(_ref46) {
  var as = _ref46.as,
      className = _ref46.className,
      children = _ref46.children,
      props = _objectWithoutProperties(_ref46, _excluded13);

  var _className = className ? "avocado-modal__content ".concat(className) : "avocado-modal__content";

  return React.createElement(StyledModalContent, Object.assign({}, props, {
    as: as || 'div',
    className: _className
  }), children);
};

var StyledModalContent = styled(Description)(_t$d || (_t$d = _$d(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  background: white;\n  margin: 0 auto;\n  max-width: 500px;\n  padding: 1em;\n  border-radius: 4px;\n  border-bottom: 1px solid red;\n"])))));

var _$e = function _$e(t) {
  return t;
},
    _t$e;

var Title = Dialog.Title;

var ModalTitle = function ModalTitle(_ref47) {
  var children = _ref47.children,
      className = _ref47.className,
      as = _ref47.as,
      props = _objectWithoutProperties(_ref47, _excluded14);

  var _className = className ? "avocado-modal__title ".concat(className) : "avocado-modal__title";

  return React.createElement(StyledTitle, Object.assign({
    as: as
  }, props, {
    className: _className
  }), children);
};

var StyledTitle = styled(Title)(_t$e || (_t$e = _$e(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  padding-bottom: 0.5em;\n  border-bottom: 1px solid ", ";\n"])), 0)), colors.gray[4]);

var _$f = function _$f(t) {
  return t;
},
    _t$f;

var Overlay = Dialog.Overlay;

var ModalOverlay = function ModalOverlay(_ref48) {
  var children = _ref48.children,
      className = _ref48.className,
      props = _objectWithoutProperties(_ref48, _excluded15);

  var _className = className ? "avocado-modal__overlay ".concat(className) : "avocado-modal__overlay";

  return React.createElement(StyledOverlay, Object.assign({}, props, {
    className: _className
  }), children);
};

var StyledOverlay = styled(Overlay)(_t$f || (_t$f = _$f(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  background: rgba(0, 0, 0, 0.6);\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: flex-start;\n  left: 0;\n  right: 0;\n  z-index: -1;\n"])))));

var _$g = function _$g(t) {
  return t;
},
    _t$g;

var ModalFooter = function ModalFooter(_ref49) {
  var children = _ref49.children,
      props = _objectWithoutProperties(_ref49, _excluded16);

  return React.createElement(StyledModalFooter, Object.assign({}, props), children);
};

var StyledModalFooter = styled.footer(_t$g || (_t$g = _$g(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  border-top: 1px solid ", ";\n  padding-top: 0.75em;\n"])), 0)), colors.gray[4]);

var _$h = function _$h(t) {
  return t;
},
    _t$h,
    _t2$a;

var Button$1 = Disclosure.Button,
    Panel = Disclosure.Panel;
var AccordionContext = createContext(null);
var Provider = AccordionContext.Provider;
var StyledAccordion = styled.div(_t$h || (_t$h = _$h(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  width: ", ";\n  font-size: ", ";\n  margin-bottom: 1.5em;\n\n  button {\n    font-size: inherit;\n  }\n"])), 0, 0)), function (_ref50) {
  var width = _ref50.width,
      fullWidth = _ref50.fullWidth;
  return fullWidth ? '100%' : width;
}, function (_ref51) {
  var size = _ref51.size;
  return size && accordionTheme.sizes[size].fontSize;
});

var Accordion = function Accordion(_ref52) {
  var children = _ref52.children,
      className = _ref52.className,
      size = _ref52.size,
      width = _ref52.width,
      fullWidth = _ref52.fullWidth,
      showIcon = _ref52.showIcon,
      iconPosition = _ref52.iconPosition,
      props = _objectWithoutProperties(_ref52, _excluded17);

  var _className = className ? "avocado-accordion ".concat(className) : "avocado-accordion";

  var accordionValues = {
    size: size,
    width: width,
    fullWidth: fullWidth,
    showIcon: showIcon,
    iconPosition: iconPosition
  };
  return React.createElement(Provider, {
    value: accordionValues
  }, React.createElement(StyledAccordion, Object.assign({
    className: _className,
    width: width,
    fullWidth: fullWidth
  }, props), children));
};

var AccordionPanel = function AccordionPanel(_ref53) {
  var children = _ref53.children,
      className = _ref53.className,
      header = _ref53.header,
      props = _objectWithoutProperties(_ref53, _excluded18);

  var context = useContext(AccordionContext);
  var iconPosition = context.iconPosition,
      showIcon = context.showIcon,
      size = context.size;

  var _className = className ? "avocado-accordion_panel ".concat(className) : "avocado-accordion_panel";

  return React.createElement(Disclosure, null, React.createElement(StyledDisclosure, Object.assign({
    className: _className
  }, props, {
    size: size,
    iconPosition: iconPosition,
    showIcon: showIcon
  }), React.createElement(Button$1, {
    className: 'avocado-accordion_panel__button'
  }, React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: iconPosition === 'right' ? 'space-between' : 'left',
    gap: 0
  }, showIcon && iconPosition === 'left' && React.createElement(ChevronDown, {
    className: 'avocado-accordion_panel__icon'
  }), header, showIcon && iconPosition === 'right' && React.createElement(ChevronDown, {
    className: 'avocado-accordion_panel__icon'
  }))), React.createElement(Panel, {
    className: 'avocado-accordion_panel__content'
  }, children)));
};

var StyledDisclosure = styled.div(_t2$a || (_t2$a = _$h(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  border-bottom: 1px solid ", ";\n\n  .avocado-accordion_panel__button {\n    cursor: pointer;\n    width: 100%;\n    text-align: left;\n    background: inherit;\n    border: none;\n    padding: ", ";\n    user-select: none;\n    font-size: ", ";\n  }\n  .avocado-accordion_panel__content {\n    background: ", ";\n    font-size: ", ";\n    margin: 0;\n    padding: 0.85em;\n  }\n\n  .avocado-accordion_panel__icon {\n    height: 1em;\n  }\n"])), 0, 0, 0, 0, 0)), accordionTheme.border, function (_ref54) {
  var size = _ref54.size;
  return size && "".concat(accordionTheme.sizes[size].margin, " 0");
}, function (_ref55) {
  var size = _ref55.size;
  return size && accordionTheme.sizes[size].fontSize;
}, accordionTheme.panelBackground, function (_ref56) {
  var size = _ref56.size;
  return size && accordionTheme.sizes[size].fontSize;
});
Accordion.defaultProps = {
  size: 'md',
  width: '20em',
  iconPosition: 'right',
  fullWidth: false,
  showIcon: true
};

var _$i = function _$i(t) {
  return t;
},
    _t$i,
    _t2$b;

var Box = function Box(_ref57) {
  var children = _ref57.children,
      className = _ref57.className,
      props = _objectWithoutProperties(_ref57, _excluded19);

  var _className = className ? "avocado-box ".concat(className) : "avocado-box";

  return React.createElement(StyledDiv, Object.assign({}, props, {
    className: _className
  }), children);
};

var StyledBoxCSS = function StyledBoxCSS(_ref58) {
  var mt = _ref58.mt,
      ml = _ref58.ml,
      mr = _ref58.mr,
      mb = _ref58.mb,
      mh = _ref58.mh,
      mv = _ref58.mv,
      m = _ref58.m,
      pt = _ref58.pt,
      pl = _ref58.pl,
      pr = _ref58.pr,
      pb = _ref58.pb,
      p = _ref58.p,
      ph = _ref58.ph,
      pv = _ref58.pv,
      block = _ref58.block;
  return css(_t$i || (_t$i = _$i(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n\n  margin: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n\n  margin-right: ", ";\n  margin-left: ", ";\n\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-right: ", ";\n  margin-left: ", ";\n\n  // Padding styles\n  padding: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n\n  padding-right: ", ";\n  padding-left: ", ";\n\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-right: ", ";\n  padding-left: ", ";\n\n  width: ", ";\n  display: ", ";\n"])), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), m && "".concat(m, "px"), mh && "".concat(mh, "px"), mh && "".concat(mh, "px"), mv && "".concat(mv, "px"), mv && "".concat(mv, "px"), mt && "".concat(mt, "px"), mb && "".concat(mb, "px"), mr && "".concat(mr, "px"), ml && "".concat(ml, "px"), p && "".concat(p, "px"), ph && "".concat(ph, "px"), ph && "".concat(ph, "px"), pv && "".concat(pv, "px"), pv && "".concat(pv, "px"), pt && "".concat(pt, "px"), pb && "".concat(pb, "px"), pr && "".concat(pr, "px"), pl && "".concat(pl, "px"), block ? "100%" : "auto", block ? "block" : "inline-block");
};

var StyledDiv = styled.div(_t2$b || (_t2$b = _$i(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  ", "\n"])), 0)), StyledBoxCSS);
Box.defaultProps = {
  block: false
};

var _$j = function _$j(t) {
  return t;
},
    _t$j,
    _t2$c;

var Separator = function Separator(_ref59) {
  var className = _ref59.className,
      props = _objectWithoutProperties(_ref59, _excluded20);

  var _className = className ? "avocado-separator ".concat(className) : "avocado-separator";

  return React.createElement(StyledHr, Object.assign({}, props, {
    className: _className
  }));
};

var CenteredCSS = function CenteredCSS(_ref60) {
  var centered = _ref60.centered;
  return centered && css(_t$j || (_t$j = _$j(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n    margin-left: auto;\n    margin-right: auto;\n  "])))));
};

var StyledHr = styled.hr(_t2$c || (_t2$c = _$j(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  border: 0;\n  margin: 0;\n  box-sizing: border-box;\n  height: 1.25px;\n  width: ", ";\n  background: ", ";\n  margin-bottom: ", ";\n  margin-top: ", ";\n  max-width: 100%;\n\n  ", ";\n"])), 0, 0, 0, 0, 0)), function (_ref61) {
  var width = _ref61.width;
  return width;
}, function (_ref62) {
  var color = _ref62.color;
  return color;
}, function (_ref63) {
  var bottomSpacing = _ref63.bottomSpacing;
  return "".concat(bottomSpacing, "px");
}, function (_ref64) {
  var topSpacing = _ref64.topSpacing;
  return "".concat(topSpacing, "px");
}, CenteredCSS);
Separator.defaultProps = {
  color: colors.gray[4],
  width: "100%",
  topSpacing: 0,
  bottomSpacing: 16
};

var getCardWidth = function getCardWidth(_ref65) {
  var fullWidth = _ref65.fullWidth,
      width = _ref65.width;
  if (fullWidth) return "100%";
  if (!width) return "auto";

  switch (typeof width) {
    case 'string':
      return "".concat(width);

    case 'number':
      return "".concat(width, "px");

    default:
      throw new Error('Please pass in a valid width');
  }
};

var _$k = function _$k(t) {
  return t;
},
    _t$k,
    _t2$d;

var Card = function Card(_ref66) {
  var children = _ref66.children,
      className = _ref66.className,
      props = _objectWithoutProperties(_ref66, _excluded21);

  var _className = className ? "".concat(className, " avocado-card") : "avocado-card";

  return React.createElement(StyledCard, Object.assign({
    className: _className
  }, props), children);
};

var PaddingStyle = function PaddingStyle(_ref67) {
  var pb = _ref67.pb,
      p = _ref67.p,
      pl = _ref67.pl,
      pr = _ref67.pr,
      pt = _ref67.pt;
  return css(_t$k || (_t$k = _$k(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  padding: ", ";\n"])), 0, 0, 0, 0, 0)), pt && "".concat(pt, "px"), pb && "".concat(pb, "px"), pl && "".concat(pl, "px"), pr && "".concat(pr, "px"), p && "".concat(p, "px"));
};

var StyledCard = styled.article(_t2$d || (_t2$d = _$k(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  width: auto;\n  display: inline-block;\n  border-style: solid;\n\n  // fullWidth should override the normal width prop\n\n  width: ", ";\n\n  // padding styles\n\n  ", ";\n\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n\n  border-width: ", ";\n  border-color: ", ";\n"])), 0, 0, 0, 0, 0, 0, 0)), function (_ref68) {
  var fullWidth = _ref68.fullWidth,
      width = _ref68.width;
  return getCardWidth({
    fullWidth: fullWidth,
    width: width
  });
}, PaddingStyle, function (_ref69) {
  var bgColor = _ref69.bgColor;
  return bgColor;
}, function (_ref70) {
  var br = _ref70.br;
  return br && "".concat(br, "px");
}, function (_ref71) {
  var showShadow = _ref71.showShadow;
  return showShadow && "0 0 6px 3px rgba(0,0,0,0.05)";
}, function (_ref72) {
  var borderSize = _ref72.borderSize;
  return borderSize && "".concat(borderSize, "px");
}, function (_ref73) {
  var borderColor = _ref73.borderColor;
  return borderColor && borderColor;
});
Card.defaultProps = {
  fullWidth: false,
  bgColor: "#fff",
  borderSize: 1,
  borderColor: "#ebebeb"
};

var _$l = function _$l(t) {
  return t;
},
    _t$l,
    _t2$e,
    _t3$6,
    _t4$5,
    _t5$2,
    _t6$2;

var Link = function Link(_ref74) {
  var children = _ref74.children,
      type = _ref74.type,
      href = _ref74.href,
      className = _ref74.className,
      prefixIcon = _ref74.prefixIcon,
      suffixIcon = _ref74.suffixIcon,
      props = _objectWithoutProperties(_ref74, _excluded22);

  var _className = className ? "avocado-link__".concat(type, " ").concat(className) : "avocado-link__".concat(type);

  var avocadoTheme = useTheme();
  if (!href) throw new Error('The href prop is compulsory. Please pass in a value for the href prop');
  return React.createElement(StyledLink, Object.assign({
    className: _className
  }, props, {
    type: type,
    theme: avocadoTheme,
    href: href
  }), prefixIcon && React.createElement(ButtonIcon, {
    className: 'link-icon--left'
  }, prefixIcon), children, suffixIcon && React.createElement(ButtonIcon, {
    className: 'link-icon--right'
  }, suffixIcon));
};

var BaseLink = function BaseLink(_ref75) {
  var shape = _ref75.shape,
      theme = _ref75.theme,
      size = _ref75.size,
      type = _ref75.type;
  return shape && css(_t$l || (_t$l = _$l(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n    color: ", "!important;\n\n    border-radius: ", ";\n\n    user-select: none;\n    transition: background, color, transform;\n    transition-duration: 0.15s;\n    transition-timing-function: ease-out;\n    user-select: none;\n    display: inline-block !important;\n\n    font-size: ", ";\n\n    display: inline-flex;\n    align-items: center;\n\n    .link-icon--left,\n    .link-icon--right {\n      height: 15px;\n      width: 15px;\n\n      display: inline-flex;\n\n      svg {\n        height: 100%;\n        width: 100%;\n        margin: auto;\n      }\n    }\n\n    .link-icon--left {\n      margin-right: 0.35em;\n    }\n\n    .link-icon--right {\n      margin-left: 0.35em;\n    }\n\n    :hover {\n      color: ", " !important;\n      text-decoration: none !important;\n      transform: translateY(-1px);\n    }\n    :active,\n    :focus {\n      outline: none;\n      transform: none;\n      box-shadow: 0 0 0 3px ", ";\n    }\n  "])), 0, 0, 0, 0, 0)), theme === null || theme === void 0 ? void 0 : theme.components.linkTheme.variants.primary.default, type !== 'default' && getButtonShape(shape), size === 'sm' ? '14px' : "inherit", theme === null || theme === void 0 ? void 0 : theme.components.linkTheme.variants.primary.hover, theme === null || theme === void 0 ? void 0 : theme.colors.blue[100]);
};

var LinkTypeSolid = function LinkTypeSolid(_ref76) {
  var type = _ref76.type,
      theme = _ref76.theme;
  return type === 'solid' && css(_t2$e || (_t2$e = _$l(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n    background: ", ";\n    color: ", " !important;\n    text-decoration: none !important;\n\n    :hover {\n      background: ", ";\n      color: ", " !important;\n    }\n  "])), 0, 0, 0, 0)), theme === null || theme === void 0 ? void 0 : theme.components.linkTheme.variants.primary.default, theme === null || theme === void 0 ? void 0 : theme.colors.white, theme === null || theme === void 0 ? void 0 : theme.components.linkTheme.variants.primary.hover, theme === null || theme === void 0 ? void 0 : theme.colors.white);
};

var LinkTypeGhost = function LinkTypeGhost(_ref77) {
  var type = _ref77.type,
      theme = _ref77.theme;
  return type === 'ghost' && css(_t3$6 || (_t3$6 = _$l(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n    background: inherit;\n    border: 2px solid ", ";\n    text-decoration: none !important;\n    color: ", " !important;\n\n    :hover {\n      border-color: ", ";\n    }\n  "])), 0, 0, 0)), theme === null || theme === void 0 ? void 0 : theme.colors.gray[3], theme === null || theme === void 0 ? void 0 : theme.components.linkTheme.variants.primary.hover, theme === null || theme === void 0 ? void 0 : theme.colors.gray[4]);
};

var LinkTypeOutline = function LinkTypeOutline(_ref78) {
  var type = _ref78.type,
      theme = _ref78.theme;
  return type === 'outline' && css(_t4$5 || (_t4$5 = _$l(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n    background: inherit;\n    text-decoration: none !important;\n    border: 1px solid ", ";\n    color: ", " !important;\n  "])), 0, 0)), theme === null || theme === void 0 ? void 0 : theme.components.linkTheme.variants.primary.hover, theme === null || theme === void 0 ? void 0 : theme.components.linkTheme.variants.primary.hover);
};

var LinkSize = function LinkSize(_ref79) {
  var size = _ref79.size,
      type = _ref79.type,
      theme = _ref79.theme;
  return size && type !== 'default' && css(_t5$2 || (_t5$2 = _$l(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), 0)), "".concat(size && (theme === null || theme === void 0 ? void 0 : theme.components.linkTheme.size[size]), " ").concat(size && (theme === null || theme === void 0 ? void 0 : theme.components.linkTheme.size[size])));
};

var StyledLink = styled.a(_t6$2 || (_t6$2 = _$l(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), 0, 0, 0, 0, 0)), BaseLink, LinkTypeSolid, LinkTypeGhost, LinkTypeOutline, LinkSize);
Link.defaultProps = {
  shape: 'curve',
  type: 'default',
  size: 'md'
};
export { Accordion, AccordionPanel, Avatar, AvatarGroup, Box, Button, CSSReset, Card, Flex, FlexItem, Heading, Image, Input, Link, Modal, ModalContent, ModalFooter, ModalOverlay, ModalTitle, Radio, RadioGroup, Select, Separator, Spinner, Text, ThemeProvider, theme };